import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { IngredientsPage } from '@/features/inventory/pages/ingredients-page';

/** `?filter=low` is where the "ingredients running low" chip on the order screen lands. */
export const Route = createFileRoute('/_app/inventory/ingredients')({
  validateSearch: z.object({
    filter: z.enum(['low']).optional().catch(undefined),
  }),
  component: IngredientsPage,
});
